import ApontamentoHeaderReportSemImplemento from "entity/Indicador/reports/ApontamentoHeaderReport";
import apontamentoImagesReport from "entity/Indicador/reports/ApontamentoImagesReport";
import apontamentoObservacaoReport from "entity/Indicador/reports/ApontamentoObservacaoReport";
import TableReportHelper from "report/helper";

export default async function apontamentoReport(indicador, visita) {
    const h = new TableReportHelper(visita.data);
    const IndicadorClass = indicador.constructor;

    const apontamentos = visita.getApontamentosByIndicador(indicador);

    const content = [];

    for (const apontamento of apontamentos) {
        // const params = visita.cliente.getParams(IndicadorClass, apontamento.tipo);
        const params = visita.cliente.getParams(IndicadorClass, apontamento.tipo, indicador.type);

        const hP = new TableReportHelper(apontamento);
        const additionalColumn = {
            label: "Operador",
            field: "operador.operador",
            width: "*",
        };
        content.push([
            ApontamentoHeaderReportSemImplemento(
                visita,
                indicador,
                apontamento,
                params,
                "Intervalo (Dias)",
                undefined,
                additionalColumn,
            ),
            hP.panel(
                [
                    hP.row(hP.title("Data Colheita"), hP.title("Data Aplicação Herbicida")),

                    hP.row(hP.dateField("dataColheita"), hP.dateField("dataAplicacao")),
                ],
                { widths: ["*", "*"] },
            ),

            apontamentoImagesReport(visita, indicador, apontamento),
            apontamentoObservacaoReport(visita, indicador, apontamento),

            h.space(),
        ]);
    }

    return content;
}
